import { useCallback } from 'react';

import { EMPTY_OBJECT } from 'shared/constants';
import { CROSS_ORIGIN_MESSAGE_TYPES } from 'entities/user';
import { IS_DIFFERENT_CONTOURS } from 'entities/application/constants';

import { isIOS, isSafariBrowser } from 'common/utils/checkBrowserType';

import config from 'config';

export const useGetContourTypeFromBContour = () => {
    const getContourTypeFromBContour = useCallback(() => new Promise<number | undefined>((resolve) => {
      window.addEventListener('message', (event) => {
        const { type, data } = event.data || EMPTY_OBJECT;

        if (
          IS_DIFFERENT_CONTOURS &&
          !isIOS &&
          !isSafariBrowser &&
          window.origin === config.contourA &&
          event.origin === config.contourB &&
          type === CROSS_ORIGIN_MESSAGE_TYPES.contourType
        ) {
          resolve(data as number | undefined);
        }
      });
    }), []);

    return getContourTypeFromBContour;
};
